import { render, staticRenderFns } from "./ShopStorePayJinqianba.vue?vue&type=template&id=120bb6d0&scoped=true"
import script from "./ShopStorePayJinqianba.vue?vue&type=script&lang=js"
export * from "./ShopStorePayJinqianba.vue?vue&type=script&lang=js"
import style0 from "./ShopStorePayJinqianba.vue?vue&type=style&index=0&id=120bb6d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120bb6d0",
  null
  
)

export default component.exports